/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionsAnswersVersionRequest {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionsAnswersVersionRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionsAnswersVersionRequest>): AppSecopsBCSQuestionsAnswersVersionRequest {
        let obj = Object.assign(new AppSecopsBCSQuestionsAnswersVersionRequest(), model);
        AppSecopsBCSQuestionsAnswersVersionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionsAnswersVersionRequest>): AppSecopsBCSQuestionsAnswersVersionRequest {
        if (!model) return null;
        return AppSecopsBCSQuestionsAnswersVersionRequest.newInstance(<AppSecopsBCSQuestionsAnswersVersionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionsAnswersVersionRequest) {
        if (!obj) return;

        models.AppSecopsBCSQuestionsAnswersVersionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionsAnswersVersionRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionsAnswersVersionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.answers) {
            for (let val of this.answers) {
                models.AppSecopsBCSQuestionsAnswerItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * All question weights; must sum to 100
     */
    answers: Array<models.AppSecopsBCSQuestionsAnswerItem>;

}
